import { useEffect, useState } from 'react';
import { Stack, Typography, useMediaQuery } from '@mui/material';
import UITabs from '@/shared/ui/ui-tabs';

import { useTranslation } from 'react-i18next';
import { SingleItem } from './ui/single-item';
import { getLang } from '@/app/helpers';

import Tab1Uz1 from '@/app/assets/images/how-it-works/uz/how-it-works-1.png';
import Tab1Uz2 from '@/app/assets/images/how-it-works/uz/how-it-works-2.png';
import Tab1Uz3 from '@/app/assets/images/how-it-works/uz/how-it-works-3.png';
import Tab1Uz4 from '@/app/assets/images/how-it-works/uz/how-it-works-4.png';
import Tab1Uz5 from '@/app/assets/images/how-it-works/uz/how-it-works-5.png';

import Tab2Uz1 from '@/app/assets/images/how-it-works/uz/how-it-works-6.png';
import Tab2Uz2 from '@/app/assets/images/how-it-works/uz/how-it-works-7.png';
import Tab2Uz3 from '@/app/assets/images/how-it-works/uz/how-it-works-8.png';
import Tab2Uz4 from '@/app/assets/images/how-it-works/uz/how-it-works-9.png';

import Tab3Uz1 from '@/app/assets/images/how-it-works/uz/how-it-works-10.png';
import Tab3Uz2 from '@/app/assets/images/how-it-works/uz/how-it-works-11.png';
import Tab3Uz3 from '@/app/assets/images/how-it-works/uz/how-it-works-12.png';
import Tab3Uz4 from '@/app/assets/images/how-it-works/uz/how-it-works-13.png';

import Tab1Ru1 from '@/app/assets/images/how-it-works/ru/how-it-works-1.png';
import Tab1Ru2 from '@/app/assets/images/how-it-works/ru/how-it-works-2.png';
import Tab1Ru3 from '@/app/assets/images/how-it-works/ru/how-it-works-3.png';
import Tab1Ru4 from '@/app/assets/images/how-it-works/ru/how-it-works-4.png';
import Tab1Ru5 from '@/app/assets/images/how-it-works/ru/how-it-works-5.png';

import Tab2Ru1 from '@/app/assets/images/how-it-works/ru/how-it-works-6.png';
import Tab2Ru2 from '@/app/assets/images/how-it-works/ru/how-it-works-7.png';
import Tab2Ru3 from '@/app/assets/images/how-it-works/ru/how-it-works-8.png';
import Tab2Ru4 from '@/app/assets/images/how-it-works/ru/how-it-works-9.png';

import Tab3Ru1 from '@/app/assets/images/how-it-works/ru/how-it-works-10.png';
import Tab3Ru2 from '@/app/assets/images/how-it-works/ru/how-it-works-11.png';
import Tab3Ru3 from '@/app/assets/images/how-it-works/ru/how-it-works-12.png';
import Tab3Ru4 from '@/app/assets/images/how-it-works/ru/how-it-works-13.png';



const HowItWorks = () => {
  const { t } = useTranslation('landing');
  const [activeTab, setActiveTab] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [imgContanerRef, setImgContanerRef] = useState<HTMLDivElement | null>(null);

  const systemLang = getLang();
  const lang = systemLang.split('_')[0] || 'ru';

  const images = [
    {
      ru: [Tab1Ru1, Tab1Ru2, Tab1Ru3, Tab1Ru4, Tab1Ru5],
      uz: [Tab1Uz1, Tab1Uz2, Tab1Uz3, Tab1Uz4, Tab1Uz5],
    },
    {
      ru: [Tab2Ru1, Tab2Ru2, Tab2Ru3, Tab2Ru4],
      uz: [Tab2Uz1, Tab2Uz2, Tab2Uz3, Tab2Uz4],
    },
    {
      ru: [Tab3Ru1, Tab3Ru2, Tab3Ru3, Tab3Ru4],
      uz: [Tab3Uz1, Tab3Uz2, Tab3Uz3, Tab3Uz4],
    },
  ] as { [key: string]: string[] }[];

  const steps1 = [
    {
      label: t('how_it_works_steps.0'),
      image: images[0][lang][0],
    },
    {
      label: t('how_it_works_steps.1'),
      image: images[0][lang][1],
    },
    {
      label: t('how_it_works_steps.2'),
      image: images[0][lang][2],
    },
    {
      label: t('how_it_works_steps.3'),
      image: images[0][lang][3],
    },
    {
      label: t('how_it_works_steps.4'),
      image: images[0][lang][4],
    },
  ];

  const steps2 = [
    {
      label: t('how_it_works_steps.5'),
      image: images[1][lang][0],
    },
    {
      label: t('how_it_works_steps.6'),
      image: images[1][lang][1],
    },
    {
      label: t('how_it_works_steps.7'),
      image: images[1][lang][2],
    },
    {
      label: t('how_it_works_steps.8'),
      image: images[1][lang][3],
    },
  ];

  const steps3 = [
    {
      label: t('how_it_works_steps.9'),
      image: images[2][lang][0],
    },
    {
      label: t('how_it_works_steps.10'),
      image: images[2][lang][1],
    },
    {
      label: t('how_it_works_steps.11'),
      image: images[2][lang][2],
    },
    {
      label: t('how_it_works_steps.12'),
      image: images[2][lang][3],
    },
  ];

  useEffect(() => {
    document.addEventListener('scroll', handleIndexChange);
    return () => {
      document.removeEventListener('scroll', handleIndexChange);
    };
  }, []);

  const handleIndexChange = () => {
    const elements = document.querySelectorAll('#step-title');
    elements.forEach((el, idx) => {
      const rect = el.getBoundingClientRect();
      if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
        setCurrentIndex(idx);
      }
    });
  };

  const isMobileHeight = useMediaQuery('(max-height:500px)');
  const isMobile = useMediaQuery('(max-width:768px)') || isMobileHeight;

  return (
    <section id='how-it-works'>
      <Stack direction='column' alignItems='center'>
        <Typography
          variant='h2'
          sx={{
            fontWeight: 600,
            fontSize: '34px',
            color: '#0B1370',
          }}
        >
          {t('how_it_works')}
        </Typography>
        <UITabs
          value={activeTab}
          onChange={(_event, value) => setActiveTab(value)}
          TabsProps={{
            sx: {
              backgroundColor: '#e7effb',
              borderRadius: '12px',
              padding: '4px',
              margin: '0 auto',
            },
          }}
          TabIndicatorProps={{
            style: {
              display: 'none',
            },
          }}
          TabPanelSx={{
            py: 0,
          }}
          sx={{
            marginTop: '40px',
          }}
          tabs={[
            {
              label: t('how_it_works_tabs.0'),
              component: (
                <SingleItem
                  steps={steps1}
                  imgContanerRef={imgContanerRef}
                  setImgContanerRef={setImgContanerRef}
                  currentIndex={currentIndex}
                  isMobile={isMobile}
                />
              ),
              sx: {
                fontSize: { xs: '12px', sm: '15px', md: '23px' },
                fontWeight: '600',
                borderRadius: '12px',
                padding: { xs: '0px 12px', sm: '15px 40px', md: '20px 52px' },
                color: '#0B1370',
                '&.Mui-selected': {
                  color: '#0B1370',
                  backgroundColor: '#fff',
                },
              },
            },
            {
              label: t('how_it_works_tabs.1'),
              component: (
                <SingleItem
                  steps={steps2}
                  imgContanerRef={imgContanerRef}
                  setImgContanerRef={setImgContanerRef}
                  currentIndex={currentIndex}
                  isMobile={isMobile}
                />
              ),
              sx: {
                fontSize: { xs: '12px', sm: '15px', md: '23px' },
                fontWeight: '600',
                padding: { xs: '0px 12px', sm: '10px 40px', md: '20px 52px' },
                borderRadius: '12px',
                color: '#0B1370',
                '&.Mui-selected': {
                  color: '#0B1370',
                  backgroundColor: '#fff',
                },
              },
            },
            {
              label: t('how_it_works_tabs.2'),
              component: (
                <SingleItem
                  steps={steps3}
                  imgContanerRef={imgContanerRef}
                  setImgContanerRef={setImgContanerRef}
                  currentIndex={currentIndex}
                  isMobile={isMobile}
                />
              ),
              sx: {
                fontSize: { xs: '12px', sm: '15px', md: '23px' },
                fontWeight: '600',
                padding: { xs: '0px 12px', sm: '10px 40px', md: '20px 52px' },
                borderRadius: '12px',
                color: '#0B1370',
                '&.Mui-selected': {
                  color: '#0B1370',
                  backgroundColor: '#fff',
                },
              },
            },
          ]}
        />
      </Stack>
    </section>
  );
};

export default HowItWorks;
